const initChangeLanguage = () => {
	const allButtons = document.querySelectorAll( 'button.language' );

	if ( !allButtons.length )
	{
		return;
	}

	allButtons.forEach( ( btn ) => {
		btn.addEventListener( 'click', () => {
			const languagePath = document.querySelector( 'body' )?.classList.contains( 'ru' ) ? 'harmony_en' : 'harmony';
			
			fetch( `/?set_object=${languagePath}` )
				.then( ( response ) => {
					if ( response.status === 200 )
					{
						window.location.reload();
					}
				} );
		} );
	} );
}

export {
	initChangeLanguage,
}
